import { ReactComponent as HaulFooterLogo } from 'assets/images/haul-footer-log.svg';

import styles from './styles.module.scss';

export const DriverFooter = () => {
  return (
    <div className={styles.root}>
      <div className={styles.title}>Powered by</div>
      <HaulFooterLogo />
    </div>
  );
};
